module.exports = __webpack_public_path__ + "catalog/items/firesafety/Running-Man-Door-Symbol-Left/Running-Man-Door-Symbol-Left.svg";